import type {
  UserApplicationProfileResponse,
  UserApplicationProfileUpsertInput,
} from '@govinity/validation/public';
import type {
  AttachmentGetPutSignedUrlResponseDto,
  AuthenticatedUserResponse,
  UserMeetingAccessResponse,
  UserMeUpdateInput,
  UserSeatsResponse,
} from '@govinity/validation';

import Api from './base';

export const PATH = '/me';

class MeApi extends Api<
  AuthenticatedUserResponse,
  AuthenticatedUserResponse,
  undefined,
  UserMeUpdateInput
> {
  getPath() {
    return PATH;
  }

  async updateMe(requestData: UserMeUpdateInput) {
    const { data } = await this.request<AuthenticatedUserResponse>({
      method: 'PUT',
      url: this.getPath(),
      data: requestData,
    });

    return data;
  }

  async updateEmail(email: string) {
    const { data } = await this.request<AuthenticatedUserResponse>({
      method: 'PUT',
      url: `${this.getPath()}/email`,
      data: { email },
    });

    return data;
  }

  async getAvatarPutSignedUrl(filename: string) {
    const { data } = await this.request<AttachmentGetPutSignedUrlResponseDto>({
      method: 'POST',
      url: `${this.getPath()}/avatar-signed-url`,
      data: {
        filename,
      },
    });

    return data;
  }

  async activate() {
    const { data } = await this.request<AuthenticatedUserResponse>({
      method: 'POST',
      url: `${this.getPath()}/activate`,
    });

    return data;
  }

  async getSeats() {
    const { data } = await this.request<UserSeatsResponse>({
      method: 'GET',
      url: `${this.getPath()}/seats`,
    });

    return data;
  }

  async getMeetingAccess() {
    const { data } = await this.request<UserMeetingAccessResponse>({
      method: 'GET',
      url: `${this.getPath()}/meeting-access`,
    });

    return data;
  }

  async getApplicationProfile() {
    const { data } = await this.request<UserApplicationProfileResponse | null>({
      method: 'GET',
      url: `${this.getPath()}/application-profile`,
    });

    return data;
  }

  async upsertApplicationProfile(requestData: UserApplicationProfileUpsertInput) {
    const { data } = await this.request<UserApplicationProfileResponse>({
      method: 'PUT',
      url: `${this.getPath()}/application-profile`,
      data: requestData,
    });

    return data;
  }
}

export default new MeApi();
